module.exports = __webpack_public_path__ + "img/logo_260_142.f2177588.png";